import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'client/componentLibrary/Button';
import { FormattedMessage } from 'react-intl';
import DonateNowButtonText from '../../../DonateNowButtonText';

const ShoppingCartActions = ({
    canAddToCart,
    classes,
    disabled,
    handleAddToCart,
    handleDonateNow,
}) => {
    return (
        <div
            className={classNames(classes.actions, {
                [classes.disabled]: disabled,
            })}
        >
            <div className={classes.actionButtons}>
                <Button
                    className={classNames(classes.addToCartButton, {
                        [classes.disabled]: !canAddToCart,
                        [classes.noDropCursor]: !canAddToCart,
                    })}
                    onClick={() => canAddToCart && handleAddToCart()}
                    disabled={!canAddToCart}
                    variant="contained"
                >
                    <FormattedMessage
                        id="shoppingCart.addToCart"
                        defaultMessage="Add to Cart"
                    />
                </Button>
                <Button
                    onClick={handleDonateNow}
                    color="secondary"
                    variant="contained"
                >
                    <DonateNowButtonText />
                </Button>
            </div>
        </div>
    );
};

ShoppingCartActions.propTypes = {
    canAddToCart: PropTypes.bool,
    classes: PropTypes.object,
    disabled: PropTypes.bool,
    handleDonateNow: PropTypes.func,
    handleAddToCart: PropTypes.func,
};

export default ShoppingCartActions;
